// Code generated by tygo. DO NOT EDIT.

//////////
// source: auth.go

export interface AuthResponse {
  access_token: string;
}

//////////
// source: game.go

export const GameStatusWaiting = "waiting";
export const GameStatusInProgress = "in_progress";
export const GameStatusCompleted = "completed";
export const GameStatusCancelled = "cancelled";
export type GameStatus = typeof GameStatusWaiting | typeof GameStatusInProgress | typeof GameStatusCompleted | typeof GameStatusCancelled;
export interface GameCreationParams {
  game_blind_id: string;
  player_limit: number /* int */;
  game_type: string;
  auto_start_count: number /* int */;
}
export interface JoinGameParams {
  game_id: string;
  buy_in_amount: number /* int64 */;
}
export interface LeaveGameParams {
  game_id: string;
}
export interface GameSeat {
  id: string;
  seat_number: number /* int32 */;
  player?: GamePlayer;
}
export interface CardDTO {
  rank: string;
  suit: string;
}
export const ActionTypeFold = "fold";
export const ActionTypeCheck = "check";
export const ActionTypeCall = "call";
export const ActionTypeBet = "bet";
export const ActionTypeRaise = "raise";
export type ActionType = typeof ActionTypeFold | typeof ActionTypeCheck | typeof ActionTypeCall | typeof ActionTypeBet | typeof ActionTypeRaise;
export interface AvailableAction {
  action_type: ActionType;
  amount?: number /* int64 */; // For call: exact amount. For bet/raise: minimum.
  max_amount?: number /* int64 */; // For bet/raise: max (player's stack)
}
export interface GamePlayer {
  id: string;
  player_id: string;
  username: string;
  status: string;
  stack: number /* int64 */;
  has_folded?: boolean;
  is_all_in?: boolean;
  cards?: CardDTO[];
  available_actions?: AvailableAction[];
  current_bet?: number /* int64 */;
}
export interface ShowdownRanking {
  game_player_id: string;
  place: number /* int32 */; // 1 = best, 2 = second, etc. Ties share the same ranking.
  hand_rank: string; // e.g. "flush", "straight", "high_card"
}
export interface HandDTO {
  id: string;
  action_on_seat?: number /* int32 */;
  action_deadline?: number /* int64 */; // Unix milliseconds
  current_betting_round: string;
  dealer_seat: number /* int32 */;
  pot: number /* int64 */;
  community_cards: CardDTO[];
  showdown_rankings?: ShowdownRanking[];
}
export interface GetGameResponse {
  game_id: string;
  game_type: string;
  game_status: GameStatus;
  player_limit: number /* int32 */;
  small_blind: number /* int64 */;
  big_blind: number /* int64 */;
  min_buy_in: number /* int64 */;
  max_buy_in: number /* int64 */;
  auto_start_count?: number /* int32 */;
  game_seats: GameSeat[];
  hand?: HandDTO;
}

//////////
// source: user.go

export interface SafeUser {
  id: string;
  username: string;
  email: string;
  is_admin: boolean;
}
export interface CurrentUserResponse {
  user: SafeUser;
  balance: number /* int64 */;
  deposit_address: string;
}
